import wrapWithProvider from './wrap-with-provider'

import './src/global.css'

export const wrapRootElement = wrapWithProvider
